module.exports = __webpack_public_path__ + "4d8147179e419a4d78d83f31ea62f3f5.png";